import * as React from "react";
import Box from "@mui/material/Box";
import { useFirebase } from "../FirebaseProvider";
import CssBaseline from "@mui/material/CssBaseline";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Header from "./Header";
import { getDatabase, ref, child, get } from "firebase/database";
import Avatar from "@mui/material/Avatar";
import { useParams, Link } from "react-router-dom";
import SearchAppBar from "./NavBar";
import draftToHtml from "draftjs-to-html";
import { convertToRaw } from "draft-js";
import { AlignHorizontalCenter } from "@mui/icons-material";
import { Helmet } from "react-helmet";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
});

export default function Recipe({}) {
  let { RecipeId } = useParams();
  console.log(RecipeId);

  const firebase = useFirebase();
  const [recipe, setRecipe] = React.useState({});
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    if (firebase) {
      const database = getDatabase(firebase.app);
      const dbRef = ref(database);
      get(child(dbRef, `recipes/${RecipeId}`)).then((snapshot) => {
        console.log(snapshot);
        if (snapshot.exists()) {
          const recipeObject = snapshot.val();
          console.log(snapshot.val());
          setRecipe(recipeObject);
        } else {
          console.log("No data available");
        }
      });
    }
  }, [firebase, RecipeId]);

  return (
    <>
      <ThemeProvider theme={darkTheme}>
        <Helmet>
          <title>Bakin' With The Bros.</title>
          <meta property="og:title" content="Bakin' With The Bros." />
          <meta property="og:description" content={recipe.RecipeName} />
          <meta
            property="og:image"
            content={
              recipe.PhotoUrl ||
              "https://firebasestorage.googleapis.com/v0/b/bakin-with-the-bros.appspot.com/o/images%2Fchip2.jpg?alt=media&token=87db18d7-5abe-4497-92f0-6de978c319a0"
            }
          />
        </Helmet>
        <Container>
          <CssBaseline />
          <Header />
          <SearchAppBar></SearchAppBar>
          <Box
            sx={{
              background: "rgba(255, 255, 255, 0.05)",
              width: "100%",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
              padding: "40px",
              marginTop: "25px",
              marginBottom: "25px",
              border: "1px solid rgba(255, 255, 255, 0.1)",
            }}
          >
            <Box
              sx={{
                maxWidth: "100%",
                width: "100%",
                color: "white",
              }}
            >
              {/* Header Section */}
              <Box sx={{ textAlign: "left", color: "white", marginBottom: "40px" }}>
                <h1 style={{ fontSize: "2.5rem", marginTop: 0, marginBottom: "10px", color: "#61dafb" }}>
                  {recipe.RecipeName}
                </h1>
                <p style={{ opacity: 0.7, fontSize: "1rem", marginBottom: "20px" }}>
                  {recipe.Date}
                </p>
              </Box>

              {/* Image Section */}
              <Box
                sx={{
                  marginBottom: "40px",
                  borderRadius: "8px",
                  overflow: "hidden",
                  border: "2px solid rgba(97, 218, 251, 0.2)",
                }}
              >
                <Box
                  component="img"
                  sx={{
                    width: "100%",
                    maxHeight: "600px",
                    objectFit: "cover",
                    transition: "transform 0.3s ease",
                    "&:hover": {
                      transform: "scale(1.02)",
                    },
                  }}
                  alt="Recipe dish"
                  src={
                    recipe.PhotoUrl ||
                    "https://firebasestorage.googleapis.com/v0/b/bakin-with-the-bros.appspot.com/o/images%2Fchip2.jpg?alt=media&token=87db18d7-5abe-4497-92f0-6de978c319a0"
                  }
                />
              </Box>

              {/* Navigation Button */}
              <Box sx={{ marginBottom: "40px" }}>
                <Button
                  component={Link}
                  to="/recipeFeed"
                  variant="outlined"
                  sx={{
                    color: "#FFFFFF",
                    border: "2px solid #FFFFFF",
                    borderRadius: "6px",
                    padding: "10px 24px",
                    fontSize: "1rem",
                    fontWeight: "600",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      borderColor: "#3CA6A6",
                      backgroundColor: "rgba(60, 166, 166, 0.1)",
                      transform: "translateY(-2px)",
                    },
                  }}
                >
                  ← Back to Recipes
                </Button>
              </Box>

              {/* Content Sections */}
              <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "40px", "@media (max-width: 960px)": { gridTemplateColumns: "1fr" } }}>
                {/* Ingredients */}
                <Box sx={{ textAlign: "left", color: "white" }}>
                  <h2 style={{ fontSize: "1.8rem", marginTop: 0, marginBottom: "20px", color: "#99fb61" }}>
                    Ingredients
                  </h2>
                  <Box
                    sx={{
                      bgcolor: "rgba(0, 0, 0, 0.2)",
                      borderRadius: "6px",
                      padding: "20px",
                      border: "1px solid rgba(255, 255, 255, 0.1)",
                      lineHeight: "1.8",
                      "& ul, & ol": {
                        paddingLeft: "20px",
                        margin: "0",
                      },
                      "& li": {
                        marginBottom: "12px",
                        color: "rgba(255, 255, 255, 0.9)",
                      },
                    }}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          recipe && recipe.IngredientList
                            ? recipe.IngredientList
                            : "",
                      }}
                    />
                  </Box>
                </Box>

                {/* Directions */}
                <Box sx={{ textAlign: "left", color: "white" }}>
                  <h2 style={{ fontSize: "1.8rem", marginTop: 0, marginBottom: "20px", color: "#61dafb" }}>
                    Directions
                  </h2>
                  <Box
                    sx={{
                      bgcolor: "rgba(0, 0, 0, 0.2)",
                      borderRadius: "6px",
                      padding: "20px",
                      border: "1px solid rgba(255, 255, 255, 0.1)",
                      lineHeight: "1.8",
                      "& ul, & ol": {
                        paddingLeft: "20px",
                        margin: "0",
                      },
                      "& li": {
                        marginBottom: "12px",
                        color: "rgba(255, 255, 255, 0.9)",
                      },
                    }}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          recipe && recipe.Directions ? recipe.Directions : "",
                      }}
                    ></div>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Container>
      </ThemeProvider>
    </>
  );
}
